class ProjectScheduleStatus {
  static PENDING = 'pending';
  static ACTIVE = 'active';
  static COMPLETED = 'completed';
  static SENT = 'sent';
  static IN_PAYMENT_PROCESS = 'in_payment_process';
  static PAID = 'paid';
  static REVIEW = 'review';
  static AUTHORIZED = 'authorized';

  constructor(private code: string) {}

  public value(): string {
    return this.code;
  }

  public static toArray(): string[] {
    return [
      ProjectScheduleStatus.PENDING,
      ProjectScheduleStatus.ACTIVE,
      ProjectScheduleStatus.COMPLETED,
      ProjectScheduleStatus.SENT,
      ProjectScheduleStatus.IN_PAYMENT_PROCESS,
      ProjectScheduleStatus.PAID,
      ProjectScheduleStatus.REVIEW,
      ProjectScheduleStatus.AUTHORIZED,
    ];
  }

  public isPending(): boolean {
    return this.code === ProjectScheduleStatus.PENDING;
  }

  public isActive(): boolean {
    return this.code === ProjectScheduleStatus.ACTIVE;
  }

  public isCompleted(): boolean {
    return this.code === ProjectScheduleStatus.COMPLETED;
  }

  public isPaid(): boolean {
    return this.code === ProjectScheduleStatus.PAID;
  }

  public isSent(): boolean {
    return this.code === ProjectScheduleStatus.SENT;
  }

  public isInPaymentProcess(): boolean {
    return this.code === ProjectScheduleStatus.IN_PAYMENT_PROCESS;
  }

  public isInReview(): boolean {
    return this.code === ProjectScheduleStatus.REVIEW;
  }

  public isAuthorized(): boolean {
    return this.code === ProjectScheduleStatus.AUTHORIZED;
  }

  public isDone(): boolean {
    return !(this.isPending() || this.isActive());
  }
}

export default ProjectScheduleStatus;
